/**
 * 0埋めされていない時間文字列(ex: 0:00)を Date オブジェクトに変換する
 * @param timeStr string
 * @returns string
 */
export const parseTime = (timeStr: string, originDate?: Date) => {
  const normalized = timeStr.padStart(5, '0');
  const resDate = new Date(originDate || new Date());
  resDate.setHours(
    Number(normalized.substring(0, 2)),
    Number(normalized.substring(3, 5))
  );

  return resDate;
};
